export const None = ''
export const Small = 'Small'
export const Normal = 'Normal'
export const Large = 'Large'
